import React, { useContext, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes } from './FetchContext';
import { InsightContext } from '.'

export const UserContext = React.createContext(null);

export const UserProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { trackError } = useContext(InsightContext);
    const [userInfo, setUserInfo] = useState({ externalKey: null, roles: [] });
    const [draftRequests, setDraftRequests] = useState(0)
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);

    const getUserInfo = async () => {
        try {
            setIsLoadingInfo(true);

            const response = await fetchAuthorized(
                ApiRoutes.User.GetMe({ withValues: true }),
                { method: HttpMethods.GET }
            );
            
            const userInfo = await response.json();

            setUserInfo(userInfo);
            setDraftRequests(userInfo.draftRequests)
            setIsLoadingInfo(false);
        }
        catch(error) {
            console.debug(error);
            trackError(error);
            setUserInfo({ externalKey: "not-allowed", roles: [] });
            setIsLoadingInfo(false);          
        }
    }

    const isUserInRole = (roleName) => {
        if (userInfo === null || userInfo.roles === null)
            return false;

        if (userInfo.roles.length === 0)
            return false;

        const role = userInfo.roles.find(x => x.roleName === roleName);
        return role !== null && role !== undefined;
    };

    const isUserInRoles = (roleNames) => {
        if (userInfo === null || userInfo.roles === null)
            return false;

        if (userInfo.roles.length === 0)
            return false;

        const role = userInfo.roles.find(x => roleNames.find(n => x.roleName === n));
        return role !== null && role !== undefined;
    };

    const { Provider } = UserContext;

    return (
        <Provider value={{
            userInfo,
            isLoadingInfo,
            getUserInfo,
            isUserInRole,
            isUserInRoles,
            draftRequests,
            setDraftRequests
        }}>
            {props.children}
        </Provider>
    );
};